/**
 * This file holds the actions/mutations types
 * For more information about why this is needed
 * check here https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types
 */

export const UPLOAD_PLACEMENT = "UPLOAD_PLACEMENT";

export const SAVE_PLACEMENT_IMAGE = "SAVE_PLACEMENT_IMAGE";
export const CLEAR_PLACEMENTS = "CLEAR_PLACEMENTS";
export const CLEAR_COMPONENT_BUFFER = "CLEAR_COMPONENT_BUFFER";
export const CLEAR_COMPONENT_PLACEMENTS = "CLEAR_COMPONENT_PLACEMENTS";
export const CLEAR_ALL = "CLEAR_ALL";
export const SET_BUFFER = "SET_BUFFER";
export const SET_COMPONENT_PLACEMENTS = "SET_COMPONENT_PLACEMENTS";
